import cs from 'classnames';
import React from 'react';
import { LoadingLabel } from 'shared/components/Loading';
import { SummaryField } from 'shared/summary/SummaryField';
import { SummaryHeader } from 'shared/summary/SummaryHeader';
import { SummarySection } from 'shared/summary/SummarySection';
import { slugs, useRentalSteps } from '../../app/steps';
import { EnumChoicesTypeInfoFragment } from '../../generated.graphql';
import { isEmployed } from '../income/Income';
import { BaseSummaryProps } from './types';
import { getEnumDisplay, getTimePeriodDisplay } from './utils';


interface Props extends BaseSummaryProps {
  workBasisEnum?: EnumChoicesTypeInfoFragment | null;
  livingExpensesEnum?: EnumChoicesTypeInfoFragment | null;
}


export const IncomeSummary = ({ application, workBasisEnum, livingExpensesEnum }: Props) => {
  const steps = useRentalSteps({slug: slugs.income});
  const income = application?.income;
  const errors = application?.validation?.income;
  const employed = income ? isEmployed(income) : false;
  const isInvalid = !!errors;
  
  const livingExpensesComponent = income?.livingExpensesPercentage ? (
    <SummaryField label="Amount of income used for living expenses" value={getEnumDisplay(income.livingExpensesPercentage, livingExpensesEnum)} />
  ) : null;

  return (
    <SummarySection>
      <SummaryHeader step={steps.this} className={cs(isInvalid && 'text-danger')}>Employment/Income</SummaryHeader>
      {!income ? <LoadingLabel alignment="left" /> : (
        <>
          <SummaryField label="Main source of income" field="workBasis" value={getEnumDisplay(income.workBasis, workBasisEnum)} errors={errors} />
          {employed ? (
            <>
              <SummaryField data={income} field="occupation" optional />
              <SummaryField data={income} field="employer" optional />
              <SummaryField data={income} label="Employers phone number" field="phoneWork" optional />
              {livingExpensesComponent}
              <SummaryField label="Worked there" optional value={getTimePeriodDisplay(income.workTimeYears, income.workTimeMonths)} />
              {/*<div>Expect income to significantly decrease: No</div>
              <div>Expect expenses to signifcantly increase: No</div>*/}
            </>
          ) : livingExpensesComponent}
        </>
      )}
    </SummarySection>
  );
}